// extracted by mini-css-extract-plugin
export default {"info":"InfoPetition_info__d6FTR","text":"InfoPetition_text__EkRDV"};